import {
  ShieldCheck,
  Fan,
  Network,
  Zap,
} from "lucide-react";

// ✅ IMPORTS de imágenes
import servicioSeguridadImg from "@/assets/images/ServicioSeguridadTrabajo.webp";
import servicioClimatizacionImg from "@/assets/images/ServicioClimitatizacion.webp"; 
import servicioInfraestructuraImg from "@/assets/images/ServicioInfrestructura.webp";
import servicioGeneralImg from "@/assets/images/ServicioGeneral.webp";

export const SERVICES = [
  {
    id: "sst",
    title: "Seguridad y Salud en el Trabajo (SST)",
    icon: ShieldCheck,
    items: [
      "Auditorías de prevención",
      "Implementación de protocolos",
      "Capacitación de brigadas",
      "Equipamiento certificado",
    ],
    whatsappMessage: "Hola, deseo cotizar el servicio de Seguridad y Salud en el Trabajo",
    image: servicioSeguridadImg,
  },
  {
    id: "hvac",
    title: "Climatización y HVAC",
    icon: Fan,
    items: [
      "Instalación de aire acondicionado",
      "Mantenimiento preventivo",
      "Ventilación industrial",
      "Sistemas de extracción",
    ],
    whatsappMessage: "Hola, deseo cotizar el servicio de Climatización y HVAC",
    image: servicioClimatizacionImg,
  },
  {
    id: "network",
    title: "Infraestructura de Red",
    icon: Network,
    items: [
      "Cableado estructurado",
      "Data Centers y servidores",
      "Fibra óptica y empalmes",
      "Certificación de puntos",
    ],
    whatsappMessage: "Hola, deseo cotizar el servicio de Infraestructura de Red",
    image: servicioInfraestructuraImg,
  },
  {
    id: "energy",
    title: "Servicios Generales y Energía",
    icon: Zap,
    items: [
      "Instalaciones eléctricas",
      "Tableros de control",
      "Mantenimiento integral",
      "Pozo a tierra y medición",
    ],
    whatsappMessage: "Hola, deseo cotizar el servicio de Servicios Generales y Energía",
    image: servicioGeneralImg,
  },
];